import { IReportData } from "common/records/Report";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_REPORT = "@report/RECEIVE_REPORT";

export const ReportActions = {
  receiveReport: (report: Partial<IReportData>) => createAction(RECEIVE_REPORT, report),
};

export type ReportActions = ActionsUnion<typeof ReportActions>;
